import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { LinkStyled } from './TrlButtonLink.styled';

export const TrlButtonLink = ({ externalLink, buttonText }) => (
  <LinkStyled href={externalLink} target="_blank" underline="none">
    <FormattedMessage id={buttonText} />
  </LinkStyled>
);

TrlButtonLink.propTypes = {
  externalLink: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
};
